import * as React from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Chip,Divider
} from "@mui/material";
import {
 Paper,
  createTheme,
  ThemeProvider,
} from "@mui/material";

const products = [
  {
    id: 1,
    name: "Sports Clean White Socks hkeo hakasd tazheeb khan",
    price: 99,
    mrp: 299,
    discount: "₹200 Off",
    image: "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/product/McVitiesDigestive.png"
  },
  {
    id: 2,
    name: "Sports Jet Black Socks",
    price: 99,
    mrp: 299,
    discount: "₹200 Off",
    image: "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/product/methi.jpeg"
  },
  {
    id: 3,
    name: "Sports GrayW",
    price: 99,
    mrp: 299,
    discount: "67% Off",
    image: "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/product/methi.jpeg"
  },
  {
    id: 4,
    name: "Sports Clean White Socks",
    price: 99,
    mrp: 299,
    discount: "67% Off",
    image: "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/product/methi.jpeg"
  }
];

export default function ProductGrid() {

  const truncateText = (text, maxLength = 40) => {
  if (!text) return "";
  return text.length > maxLength
    ? text.substring(0, maxLength) + "..."
    : text;
};




const theme = createTheme({
  typography: {
    fontFamily: "Roboto, sans-serif",
  },
  palette: {
    success: { main: "#2ecc7a" },
  },
});

 function PriceCard() {
  return (
    <ThemeProvider theme={theme}>
      <Paper
        elevation={2}
        sx={{
          display: "flex",
          alignItems: "stretch",
          borderRadius: { xs: "12px", sm: "16px" },
          overflow: "hidden",
          boxShadow: "0 1px 4px rgba(0,0,0,0.10), 0 0 0 1px rgba(0,0,0,0.06)",
          width: { xs: "100%", sm: "fit-content" },
          maxWidth: { xs: "100%", sm: 360 },
        }}
      >
        {/* Trial Price */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            flex: 1,
            px: { xs: 2, sm: 3 },
            py: { xs: 2, sm: 2.5 },
            gap: 0.25,
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 700,
              color: "#1a1a1a",
              fontSize: { xs: "13px", sm: "15px" },
              lineHeight: 1.2,
            }}
          >
            Trial Price
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: "#2ecc7a",
              fontSize: { xs: "22px", sm: "26px" },
              lineHeight: 1.15,
              mt: 0.25,
            }}
          >
            ₹99.00
          </Typography>
        </Box>

        {/* Divider */}
        <Divider
          orientation="vertical"
          flexItem
          sx={{ my: { xs: 1.5, sm: 1.75 }, borderColor: "#e8e8e8" }}
        />

        {/* MRP */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            flex: 1,
            px: { xs: 2, sm: 3 },
            py: { xs: 2, sm: 2.5 },
            gap: 0.25,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: 400,
              color: "#b0b0b0",
              fontSize: { xs: "12px", sm: "14px" },
              lineHeight: 1.2,
            }}
          >
            MRP
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 400,
              color: "#c0c0c0",
              fontSize: { xs: "18px", sm: "22px" },
              lineHeight: 1.2,
              mt: 0.25,
              textDecoration: "line-through",
              textDecorationColor: "#c0c0c0",
            }}
          >
            ₹299
          </Typography>
        </Box>
      </Paper>
    </ThemeProvider>
  );
}

  return (
    <Box sx={{ p: 2, backgroundColor: "#f6f7fb", minHeight: "100vh" }}>
      <Grid container spacing={2}>
        {products?.map((item) => (
          <Grid item xs={6} key={item.id}>
          <Card
  sx={{
    borderRadius: 4,
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    position: "relative",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    p: 1
  }}
>
  {/* Discount Badge */}
  <Chip
    label={item.discount}
    size="small"
    sx={{
      position: "absolute",
      top: 10,
      right: 10,
      backgroundColor: "#e6f4ea",
      color: "#1e8e3e",
      fontWeight: 600,
      zIndex: 2
    }}
  />

  <CardContent
    sx={{
      display: "flex",
      flexDirection: "column",
      flex: 1,
      textAlign: "center",
      gap: 1
    }}
  >
    {/* IMAGE AREA (fixed height for consistency) */}
    <Box
      sx={{
        height: 110,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Box
        component="img"
        src={item.image}
        alt={item.name}
        sx={{
          maxHeight: 100,
          maxWidth: "100%",
          objectFit: "contain"
        }}
      />
    </Box>

    {/* TITLE (fixed 2-line space) */}
    <Typography
      variant="subtitle1"
      sx={{
        fontWeight: 600,
        lineHeight: "20px",
        height: 40, // exactly 2 lines
        overflow: "hidden",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 2
      }}
    >
      {item.name}
    </Typography>

    {/* PRICE BOX */}
<PriceCard/>

    {/* PUSH BUTTON TO BOTTOM */}
    <Box sx={{ mt: "auto", pt: 1 }}>
      <Button
        fullWidth
        variant="outlined"
        sx={{
          borderRadius: 3,
          textTransform: "none",
          fontWeight: 600,
          borderColor: "#1e8e3e",
          color: "#1e8e3e",
          "&:hover": {
            backgroundColor: "#e6f4ea",
            borderColor: "#1e8e3e"
          }
        }}
      >
        Add
      </Button>
    </Box>
  </CardContent>
</Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}